// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1C0TP","errorLogs":"EditorFooter_errorLogs__leVkR"};